import gql from 'graphql-tag';

const CREATE_REPORT = gql`
  mutation($input: ReportInput!) {
    createReport(input: $input) {
      reportId
      name
      description
      layout
      createdBy {
        userId
        name
        email
      }
      createdTime
      charts {
        chartId
        name
        description
        groupBy #GroupBy
        metrics {
          metricId
          name
          attribute
          metricFunction # MetricFunction
          filterCondition
          metricOrder
        }
        entity
        createdBy {
          userId
          name
          email
        }
        createdTime
        defaultChartType # when the user request to view the chart, it will be rendered in this type first time then the user can switch chart types. It will be available in single GET only.
        # possibleChartTypes
      }
    }
  }
`;

const UPDATE_REPORT = gql`
  mutation($reportId: ID!, $input: ReportInput!) {
    updateReport(reportId: $reportId, input: $input) {
      reportId
      name
      description
      layout
      reportType
      reportConfig
      createdBy {
        userId
        name
        email
      }
      createdTime
      fullScreenModeEnabled  
      fullScreenModeRefreshInterval
      charts {
        chartId
        name
        description
        groupBy #GroupBy
        metrics {
          metricId
          name
          attribute
          metricFunction # MetricFunction
          filterCondition
          metricOrder
        }
        entity
        createdBy {
          userId
          name
          email
        }
        createdTime
        defaultChartType # when the user request to view the chart, it will be rendered in this type first time then the user can switch chart types. It will be available in single GET only.
        # possibleChartTypes
      }
    }
  }
`;

const SHARE_REPORT = gql`
  mutation($input: ShareReportInput!) {
    shareReport(input: $input)
  }
`;

const CREATE_DASHBOARD_SHARE_LINK = gql`
  mutation createDashboardShareLink($input: CreateDashboardShareInput!) {
    createDashboardShareLink(input: $input)
  }
`;

const DELETE_REPORT = gql`
  mutation($reportId: ID!) {
    deleteReport(reportId: $reportId)
  }
`;

const DOWNLOAD_PDF_REPORT = gql`
  query(
    $module: String
    $type: String
    $reportId: ID!
    $filterConditions: JSON
  ) {
    generateAndSendReport(
      module: $module
      type: $type
      reportId: $reportId
      filterConditions: $filterConditions
    )
  }
`;

const UPDATE_REPORT_EXPORT_CONFIG = gql`
  mutation($input: ReportExportConfigInput!) {
    updateReportExportConfig(input: $input) {
      reportType
      pdfReportConfig {
        clientLogo
        autoGeneratedText
      }
    }
  }
`;

const UPDATE_REPORT_SCHEDULE = gql`
  mutation($input: ConfigureReportScheduleInput!) {
    updateReportSchedules(input: $input) {
      schedules {
        id
        scheduleDefinition
        userType
        filterCondition
        notificationTemplate {
          id
          name
          subject
          content
        }
        shareUsers {
          user {
            userId
            name
          }
          client {
            accountId
            name
          }
        }
      }
    }
  }
`;

const DELETE_PDF_HISTORY = gql`
  mutation($ids: [ID]!) {
    bulkDeleteDownloads(inventoryIds: $ids)
  }
`;

export {
  CREATE_REPORT,
  UPDATE_REPORT,
  DELETE_REPORT,
  SHARE_REPORT,
  CREATE_DASHBOARD_SHARE_LINK,
  DOWNLOAD_PDF_REPORT,
  UPDATE_REPORT_EXPORT_CONFIG,
  UPDATE_REPORT_SCHEDULE,
  DELETE_PDF_HISTORY
};
